import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { apiPostAuth } from "../utils/api";

const ProtectedRoute = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [verified, setVerified] = useState(false);
  const [isAuthenticated , setIsAuthenticated] = useState(false);

  useEffect(() => {
    const verifyEmail = async () => {
      
      try{
        const response = await apiPostAuth("account/check_email_verified.php");
        if(response.status === "error"){
          setIsAuthenticated(false);
        }else{
          setIsAuthenticated(true);
          setVerified(response.is_verified === 1);
        }
        setLoading(false);
      }catch(error){
        
      }
    };
    verifyEmail();
  }, []);

  if (loading) return <div>Loading...</div>;

  if (!isAuthenticated) return <Navigate to="/login" replace />;

  return verified ? children : <Navigate to="/verify-email" replace />;
};

export default ProtectedRoute;
